import React from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';

import PricingList from '../../../../components/SiteAdmin/Pricing/PricingList';
import Loader from '../../../../components/Common/Loader/Loader';
import getAllPricingQuery from './getAllPricing.graphql';
import messages from '../../../../locale/messages';
import { withQuery } from '../../../../hoc/withGraphql';
class Pricing extends React.Component {

  render() {
    const { formatMessage } = this.props.intl;
    const { pricingDetails, pricingDetails: { loading } } = this.props;

    return (
      <Loader type={"page"} show={loading}>
        <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.manageFare)}</h1>
        {!loading && <PricingList pricingDetails={pricingDetails} />}
      </Loader>
    );
  }
}

export default compose(
  injectIntl,
  withQuery(getAllPricingQuery, {
    name: 'pricingDetails',
    options: {
      ssr: false,
      fetchPolicy: 'network-only',
      variables: {
        currentPage: 1,
        searchKeyword: ''
      }
    }
  }))(Pricing);